export default __webpack_public_path__ + "static/offer2-3802faae3a6d77af591ff1c871a9fe49.jpg";